import { NavLink } from "react-router-dom";
import links from "../utils/links";
import { useSelector } from "react-redux";
import { isPremiumUser } from "../utils/premiumUtils";

const NavLinks = (props) => {
  const { toggle } = props;
  const { startupData } = useSelector((store) => store.startupContents);
  const { currentUser } = useSelector((store) => store.users);

  const roleFromStartup = startupData?.userInfo?.group || "";
  const roleFromUser = currentUser?.role || "";
  const isAdmin = [roleFromStartup, roleFromUser].some(
    (role) => role?.toLowerCase() === "admin"
  );
  const isPremium = isPremiumUser(startupData?.userSubscription);

  const filteredLinks = links.filter((link) => {
    const isAdminOnlyLink = link.text === "all accounts" || link.text === "settings";
    if (isAdminOnlyLink && !isAdmin) return false;
    if (link.text === "own books" && !isPremium) return false;
    return true;
  });

  return (
    <div className="nav-links">
      {filteredLinks.map((link) => {
        const { id, text, path, icon } = link;
        return (
          <NavLink
            to={path}
            className={({ isActive }) => {
              return isActive ? "nav-link active" : "nav-link";
            }}
            key={id}
            onClick={toggle}
          >
            <span className="icon">{icon}</span>
            {text}
          </NavLink>
        );
      })}
    </div>
  );
};
export default NavLinks;